// client/src/pages/GenesisHub.js
// The hub paints its final treatment on the first frame: no asset gate, no
// full-screen loader wash, no opacity fade-in. Data/artwork populate the
// shell; they never re-colour it.

import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import "./GenesisHub.css";
import CphereHeaderLogo from "../components/CphereHeaderLogo";


// Tile artwork is served from stable, versioned public/ URLs rather than
// hashed webpack emissions, so `public/index.html` can name the exact same URL
// in a route-aware <link rel="preload"> during HTML parse. The preload and the
// rendered background therefore resolve to one request, already in flight
// before this component mounts. Bump the version in the filename to bust cache.
//
// The EXTENSION is part of a tile's identity, not a formality: a tile whose
// artwork is an animated GIF has to stay a GIF, because any still derivative
// can only carry frame 0. #397/#519 right-sized every tile into a `.jpg`
// derivative and excluded the animated ones BY FILENAME, which missed the
// animated GIFs that were named `.jpg` and shipped them frozen. Pass the real
// extension for animated artwork.
const TILE = (name, ext = "jpg") =>
  `${process.env.PUBLIC_URL || ""}/tiles/${name}.v1.${ext}`;

const mediaPlannerImage = TILE("mediaplanner");
const mediaCampaignsImage = TILE("campaignoptimization");
const authorizeImage = TILE("authorize");
const fundingImage = TILE("billing");
const integrationsImage = TILE("integrations");

const GenesisHub = () => {
  const navigate = useNavigate();

  const go = useCallback((path) => navigate(path), [navigate]);

  return (
    <div className="genesishub-page-container">
      <div className="genesishub-ready-shell">
        <div className="genesishub-page-content">
          <CphereHeaderLogo
            alt="Cphere"
            className="genesishub-poweredby-logo"
            onClick={() => go("/dashboard")}
            style={{ cursor: "pointer" }}
          />

          <div className="genesishub-hero-container">
            <div className="genesishub-hero-pill">
              <span className="genesishub-hero-pill-label cphere-hero-pill-wordmark">Campaign</span>
              <span className="genesishub-hero-pill-tag cphere-hero-pill-tag">Creation</span>
            </div>
            <div className="genesishub-hero-shimmer-bar" />
          </div>

          <div className="genesishub-tile-grid">
            <button
              className="genesishub-tile"
              style={{ backgroundImage: `url(${mediaPlannerImage})` }}
              onClick={() => go("/sherloc-media-planner")}
              type="button"
            >
              <span className="genesishub-beta-tag">Strategy</span>
              <span className="genesishub-tile-label">Create</span>
            </button>

            <button
              className="genesishub-tile"
              style={{ backgroundImage: `url(${mediaCampaignsImage})` }}
              onClick={() => go("/sherloc-media-campaigns")}
              type="button"
            >
              <span className="genesishub-beta-tag">Campaigns</span>
              <span className="genesishub-tile-label">Media</span>
            </button>

            <button
              className="genesishub-tile"
              style={{ backgroundImage: `url(${authorizeImage})` }}
              onClick={() => go("/authorize")}
              type="button"
            >
              <span className="genesishub-tile-label">Authorize</span>
            </button>

            <button
              className="genesishub-tile"
              style={{ backgroundImage: `url(${fundingImage})` }}
              onClick={() => go("/billing")}
              type="button"
            >
              <span className="genesishub-tile-label">Fund</span>
            </button>

            {/* Platform / Connect */}
            <button
              className="genesishub-tile genesishub-integrations-tile"
              style={{ backgroundImage: `url(${integrationsImage})` }}
              onClick={() => go("/integrations")}
              type="button"
            >
              <span className="genesishub-beta-tag">Connect</span>
              <span className="genesishub-tile-label">Platform</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenesisHub;
